import { list } from './list';

export const schools = { list };
